// extracted by mini-css-extract-plugin
module.exports = {"root":"TopologyPage-module__root__1mhpo","spinner":"TopologyPage-module__spinner__30gCZ","map-data-is-loading":"TopologyPage-module__map-data-is-loading__4Z4Yy"};